module.exports = __webpack_public_path__ + "static/media/PrivacyPolicy@3x.f85c4693.png";